import axios from 'axios';
import { convertPath, electronConfig, live_stream, localRecording } from '../../libs/roomnew';
import { v4 as uuidv4 } from 'uuid';
export default class KinoStreamService{
    constructor(type){
        this.serviceType=type;
        this.streamServers=[];
        this.selectedServer=undefined;
        this.events={};
        this.socketOptions = {
            transports: ['websocket'],
            upgrade: false,
            secure: true,
            reconnection: true,
            reconnectionAttempts: 3,
            randomizationFactor: 0.3,
            reconnectionDelay: 500,
            timeout: 10000,
            query: {
                framespersecond: 30,
                audioBitrate: 44100
            }
        };
        this.socket=undefined;
        this.session_id=null;
        this.options={};
        this.resumeOnConnect=false;
        this.rtmpDestination=null;
        window.disconnectSocket=()=>{
            this.socket.disconnect();
            setTimeout(() => {
                this.resumeOnConnect=true;
                this.connectSocket();
            }, 1500);
        };
    }

    getServers(){
        axios.get(convertPath(`/services/stream/servers/${this.serviceType}`)).then((response) =>{
            if(response.data && response.data.length){
                this.streamServers=response.data;
            }
        });
    };

    async isServerAvailable(server){
        let server_status = await axios.get(`https://${server}/status`).then(res => res).catch(err => err);
        if(server_status.data && server_status.data.percentage.idle >= 20){return true}else{return false};
    };

    selectServer(){
        console.log(`Selecting stream server from list`,this.streamServers);
        this.selectedServer=this.streamServers.find(async server=>await this.isServerAvailable(server));
    };

    connectSocket(onConnectCb=false){
        console.log(`Connecting to stream server `,this.selectedServer);
        this.socket = io('https://'+this.selectedServer, this.socketOptions);
        this.socketEvents(onConnectCb);
    };
    setRtmpDestination(dest){
        this.rtmpDestination=dest;
        this.socket.emit('config_rtmp_destinations',dest);
    };
    socketStartStream(config){
        return new Promise((resolve,reject)=>{
            this.selectServer();
            if(!this.selectedServer){
                reject(false);
                throw new Error("Service unavailable");
            }
            this.connectSocket((connected)=>{
                if(connected){
                    // this.session_id=uuidv4();
                    let options={
                        ...config,
                        session_id:this.session_id
                    };
                    this.options=options;
                    if(config.rtmp){
                        this.setRtmpDestination(config.rtmp);
                    }
                    this.socket.emit('start',options);
                    resolve(this.session_id);
                }else{
                    reject(false);
                }
            });
            
        });
        
    };

    generateSessionID(){
        this.session_id=uuidv4();
    };
    resumeStream(){
        return new Promise((resolve,reject)=>{
            this.events['ready_to_start']=()=>{
                resolve();
            };
            this.socket.emit('start',{...this.options,session_id:this.session_id,filename:this.currentFilename,resume:true});
        });
    };
    sendData(data){
        try {
            this.socket.compress(true).emit('binarystream',data);
        } catch (error) {
        }
    };

    socketEvents(connectedCallback=false) {

        this.socket.on("connect",()=>{
            console.log("Socket connection to server was successfull",this.socket)
            if(connectedCallback){
                connectedCallback(true);
            }
            if(this.resumeOnConnect){
                if(this.serviceType=="stream"){
                    this.resumeLiveStream();
                }else{
                    localRecording.onSocketReconnected(true);
                }
            }
        });
        this.socket.on('connect_timeout', (timeout) => {
            connectedCallback(false);
            console.error('_socket_timeout', timeout)
            if(live_stream.video_stream){
                live_stream.video_stream.stop(); 
            }
        });
        this.socket.on('error', (error) => {
            console.error('_socket_error', error)
        });

        this.socket.on('connect_error', (err) => {
            connectedCallback(false);
            console.error('_socket_connect_error', err)
            if(live_stream.video_stream){
                live_stream.video_stream.stop(); 
            }
        });
        this.socket.on('process_end', (data) => {
            console.error('_socket_process_end', data)
            this.onRecordingProccessEnd(data);
        });
        this.socket.on('process_merge', (data) => {
            console.error('_socket_process_merge started', data)
            this.onRecordingMergeProcess(data);
        });
        this.socket.on('message',(m) => {
            console.error('_socket_message', m)
            if(m && m.recording_start){
                this.storeNewRecording(m);
            }
        });

        this.socket.on('fatal', (m) => {
            if(live_stream.video_stream){
                live_stream.video_stream.stop(); 
            }
            console.error('_socket_fatal', m)
        });
        this.socket.on('ready_to_start',(message)=>{
            console.log("Recorder ready to start:",message);
            if(this.events['ready_to_start']){
                this.events['ready_to_start'].call(this,message);
                delete this.events['ready_to_start'];
            }
        });
        this.socket.on('disconnect', (m) => {
            console.log('Recording socket disconnected', m)
            this.resumeOnConnect=false;
            if(this.serviceType=="stream"){
                if(live_stream.mediaRecorder){
                    try {   
                        live_stream.mediaRecorder.stop();
                    } catch (error) {
                        
                    }
                }
            }
            localRecording.onSocketDisconnected();
        });

        this.socket.io.on('reconnect', (attempt) => {
            console.log("socket reconnected");
            this.resumeOnConnect=false;
            if(this.serviceType=="stream"){
                this.resumeLiveStream();
            }else{
                localRecording.onSocketReconnected(true);
            }
        });

        this.socket.io.on('reconnect_attempt', (arg) => {
            this.socket.io.opts.query = {
               reconnect:true,
               framespersecond: 30,
               audioBitrate: 44100
            };
            console.log("Trying reconnecting the socket",arg);
        });
        this.socket.io.on('reconnect_failed', () => {
            console.error("socket reconnect_failed");
            localRecording.onReconnectFailed();
        });
    }
    onRecordingProccessEnd(info){
        try {
            localRecording.onReadyForDownload(info.filename);
            this.closeSocket();
        } catch (error) {
            
        }
    }
    onRecordingMergeProcess(info){
        // localRecording.onRecordingMerge(info);
        // this.closeSocket();
    };
    endRecording(){
        try {
            this.socket.emit('stop_recording','');
        } catch (error) {
            
        }
    };
    closeSocket(){
        try {
            this.options={};
            this.socket.disconnect();
            this.socket.destroy();
            this.socket = null
        } catch (error) {
        }
    };

    async storeNewRecording(data){
        this.currentFilename=data.filename;
        localRecording.recordingFiles.push({
            filename:data.filename,
            downloadUrl: data.downloadUrl
        });
        axios.post(convertPath(`/services/recording/new`),{
            kino_id:ROOM_NAME,
            server_domain:data.downloadServer,
            recording_hash:data.hash,
            filename:data.filename,
            region:'europe',
            is_main:data.isMain,
            file_type:data.isPart ? 'part' : 'full',
            session_id:this.session_id
        },await electronConfig()).then((response) =>{
            console.log("Got recording response",response.data);

        }).catch(err=>{
            console.error(err);
        });
    };

    async getRecordingStatus(filename){
        try {
            let response= await axios.post(convertPath(`/services/recording/status`),{
                kino_id:ROOM_NAME,
                filename:filename
            },await electronConfig());
            if(response.data && response.data.status){
                return response.data.status;
            }else{
                return 'not_found';
            }
        } catch (error) {
            return 'not_found';
        }
    };

    resumeLiveStream(){
        if(live_stream.streamingStatus == "streaming" || live_stream.streamingStatus == "paused"){
            if(this.options.rtmp){
                this.setRtmpDestination(this.options.rtmp);
                this.resumeStream().then(()=>{
                    live_stream.createMediaRecorder();
                });
            }
        }
    }
};